import type { Category } from "../Category.js";
import { productsAnchorPathMap } from "./productsAnchorPathMap.js";
import { productsPathMap } from "./productsPathMap.js";

export function getCategoryPath({ locale, urlSlug }: Pick<Category, "locale" | "urlSlug">): string {
	return `${productsPathMap[locale]}/${urlSlug}${productsAnchorPathMap[locale]}`;
}
